import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39d5f97c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "product" }
const _hoisted_2 = {
  key: 0,
  id: "product-content"
}
const _hoisted_3 = { id: "product-field" }
const _hoisted_4 = { id: "product-left" }
const _hoisted_5 = { id: "product-gallery" }
const _hoisted_6 = { id: "product-side-gallery" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { id: "product-image-div" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  playsinline: "",
  autoplay: "",
  muted: "",
  loop: "",
  id: "product-video"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { id: "product-right" }
const _hoisted_14 = { id: "product-name" }
const _hoisted_15 = { id: "product-price" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Checkout", -1))
const _hoisted_17 = { class: "smol" }
const _hoisted_18 = { id: "product-details" }
const _hoisted_19 = {
  key: 0,
  id: "related-brands"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Related: ")
const _hoisted_21 = ["src"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { id: "social-container" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Socials: ")
const _hoisted_25 = { id: "social-brand-container" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["href"]
const _hoisted_28 = { id: "social-artist-container" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "artist-icon" }, "🎨", -1))
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 1,
  id: "social-artist-container"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "artist-icon" }, "🎨", -1))
const _hoisted_33 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.product)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getImagesAdjusted, (image, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "product-gallery-image-div",
                      key: index,
                      onClick: ($event: any) => (_ctx.imgClick(index))
                    }, [
                      _createElementVNode("img", {
                        class: "product-gallery-image",
                        src: _ctx.galleryImage(image)
                      }, null, 8, _hoisted_8)
                    ], 8, _hoisted_7))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (!_ctx.showWebm)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        id: "product-image",
                        class: _normalizeClass({isClickable:_ctx.getImagesAdjusted[_ctx.curImage][1] === 'webm'}),
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImage && _ctx.handleImage(...args))),
                        src: _ctx.productImage(_ctx.getImagesAdjusted[_ctx.curImage])
                      }, null, 10, _hoisted_10))
                    : _createCommentVNode("", true),
                  (_ctx.showWebm)
                    ? (_openBlock(), _createElementBlock("video", _hoisted_11, [
                        _createElementVNode("source", {
                          src: `${_ctx.interpolateAsset(_ctx.getImagesAdjusted[_ctx.curImage][0])}.webm`,
                          type: "video/webm"
                        }, null, 8, _hoisted_12)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.product.name), 1),
              _createElementVNode("div", _hoisted_15, " USD$" + _toDisplayString((_ctx.product.price / 100).toFixed(2)), 1),
              _createElementVNode("div", {
                id: "product-add-to-cart",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addToCart()))
              }, "Add to Cart"),
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cartNavigate())),
                class: _normalizeClass(_ctx.animHandler),
                id: "product-checkout"
              }, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.cartCount), 1)
              ], 2),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.details, (detail, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, " ✔️ " + _toDisplayString(detail), 1))
                }), 128))
              ]),
              (this.product && this.brands)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectedBrands, (brand, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        id: "brand-container"
                      }, [
                        _createElementVNode("img", {
                          id: "brand-icon",
                          src: _ctx.interpolateAsset(brand.brand_asset)
                        }, null, 8, _hoisted_21),
                        _createElementVNode("div", {
                          class: "brand-link",
                          onClick: ($event: any) => (_ctx.brandNavigate(brand.id))
                        }, _toDisplayString(brand.name), 9, _hoisted_22)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("img", {
                    id: "brand-icon",
                    src: _ctx.interpolateAsset(_ctx.product.brand_asset)
                  }, null, 8, _hoisted_26),
                  _createElementVNode("a", {
                    target: "_blank",
                    href: _ctx.product.brand_url,
                    id: "product-brand-url"
                  }, _toDisplayString(_ctx.product.brand), 9, _hoisted_27)
                ]),
                (_ctx.artistIsArray)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.product.artist, (artist, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("a", {
                            target: "_blank",
                            href: _ctx.product.artist_url[index],
                            class: "product-artist"
                          }, _toDisplayString(artist), 9, _hoisted_30)
                        ])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("a", {
                        target: "_blank",
                        href: _ctx.product.artist_url,
                        class: "product-artist"
                      }, _toDisplayString(_ctx.product.artist), 9, _hoisted_33)
                    ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}